import { Box } from '@chakra-ui/react';
import Field from 'components/general/Field';
import { useFormContext, useWatch } from 'react-hook-form';

function DocumentSettingsForm() {
  const { getValues } = useFormContext();
  const nonExpiring = useWatch({ name: 'nonExpiring' });

  return (
    <Box>
      <Field name="name" label="Name" isReadOnly />
      <Field name="expiresOn" label="Expiration Date" type="date" isDisabled={nonExpiring} mt={4} />
      <Field
        name="nonExpiring"
        label="Non-Expiring"
        type="checkbox"
        mt={4}
        register={{
          validate: value => !!getValues('expiresOn') || value,
        }}
      />
    </Box>
  );
}

export default DocumentSettingsForm;
